import { SectionDimensions } from '../../schemas/content-schema-v1';

export const calculateMaxRecords = (isGuestUser: boolean, props: AnyObject, defaultMax = 9): number => {
    let dims: SectionDimensions = props.unauthenticated_dimensions as SectionDimensions;
    if (!isGuestUser) {
        dims = props.authenticated_dimensions as SectionDimensions;
    }
    return dims?.cols && dims?.rows ? dims.cols * dims.rows : defaultMax;
};

export const calculateGridItemSize = (isGuestUser: boolean, props: AnyObject): string => {
    let dims: SectionDimensions = props.unauthenticated_dimensions as SectionDimensions;
    if (!isGuestUser) {
        dims = props.authenticated_dimensions as SectionDimensions;
    }
    const mapGridCols = {
        1: '4:4',
        2: '4:8',
        3: '4:12',
        4: '3:12',
    }; // in case needed 5: '2:10', 6: '2:12'

    const cols = dims?.cols < 4 ? dims.cols : 4;

    // @ts-expect-error * Automated Type Error Fix
    return `4:4@x-small 4:8@medium ${mapGridCols[cols]}@large`;
};
